module.exports = __webpack_public_path__ + "img/contato_mask.2e76d105.svg";